/** @format */

import spinner from '../../../Assets/spinner.gif';
function PageSpinner() {
  return (
    <div
      style={{
        width: '100%',
        height: '90vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={spinner}
        alt="Loading..."
        style={{ width: '100px', height: '100px' }}
      />
    </div>
  );
}

export default PageSpinner;
